import { StateActions } from '@app/core/store/shared/state';
import { Action } from '@ngrx/store';
import { ResultSet } from '@app/shared/models/result-set';
import { SearchCriteria } from '@app/shared/models/search-criteria';
import { Template } from '@app/shared/models/template';

export enum MessageTemplateActionTypes {
  SEARCH = 'Message Template Search',
  SEARCH_SUCCESS = 'Message Template Search Success',
  SEARCH_ERROR = 'Message Template Search Error',
  PAGINATE = 'Message Template Paginate',
  PAGINATE_SUCCESS = 'Message Template Paginate Success',
  PAGINATE_ERROR = 'Message Template Paginate Error',
}

export class Search implements Action {
  readonly type = MessageTemplateActionTypes.SEARCH;
  constructor(public payload: SearchCriteria) {}
}

export class SearchSuccess implements Action {
  readonly type = MessageTemplateActionTypes.SEARCH_SUCCESS;
  constructor(public payload: ResultSet<Template>) {}
}

export class SearchError implements Action {
  readonly type = MessageTemplateActionTypes.SEARCH_ERROR;
  constructor(public payload: any) {}
}

export class Paginate implements Action {
  readonly type = MessageTemplateActionTypes.PAGINATE;
  constructor(public payload: SearchCriteria) {}
}

export class PaginateSuccess implements Action {
  readonly type = MessageTemplateActionTypes.PAGINATE_SUCCESS;
  constructor(public payload: ResultSet<Template>) {}
}

export class PaginateError implements Action {
  readonly type = MessageTemplateActionTypes.PAGINATE_ERROR;
}

export type MessageTemplateCustomAction =
  Search |
  SearchSuccess |
  SearchError |
  Paginate |
  PaginateSuccess |
  PaginateError;

export class MessageTemplatesActions extends StateActions<Template> {

  search(payload: SearchCriteria): void {
    this.store.dispatch(new Search(payload));
  }

  paginate(payload: SearchCriteria): void {
    this.store.dispatch(new Paginate(payload));
  }

  searchSuccess(payload: ResultSet<Template>): void {
    this.store.dispatch(new SearchSuccess(payload));
  }

  paginateSuccess(payload: ResultSet<Template>): void {
    this.store.dispatch(new PaginateSuccess(payload));
  }
}
